import { ReduxService } from 'dashboard-services/services';
import TimeService from 'dashboard-services/services/TimeService';

import { commonDatalakeActions } from 'actions/modules/datalake';
import { builderDataStorageCreatorActions } from 'actions/modules/dataStorage/creator';
import basicInsightActions from 'actions/modules/insight/basic';
import { settingsMyAccountActions } from 'actions/modules/myAccount';
import { routing } from 'routing';

export const settingsInitialState = {
  columns: [],
  companyTags: [],
  symbolsDisplay: {},

  dashboardUserTabs: [],
  defaultGroup: undefined,
  defaultPage: undefined,
  definedTime: TimeService.UTC,
  downloadFormat: builderDataStorageCreatorActions.basicDownloadFormats[0],
  additionalParameters: "false",
  storageScreen: routing.dataStorage.routing.creator.hashes.table,
  language: "eng",
  userName: "",
  storageGroupsHidden: false,
  datalakeLayout: commonDatalakeActions.DATALAKE_LAYOUT.VERSIONS,
  approvalsListView: commonDatalakeActions.APPROVALS_LIST_VIEW.VERSIONS,

  favoritePipelines: [],
  favoriteGroups: [],
  favoriteInsights: [],
  favoriteDataPreps: [],

  recents: [],
  recentTasks: [],
  colorPalettes: [],
  formulaPanelConstants: [],
  formulaPanelRecents: [],

  darkmode: settingsMyAccountActions.DARK_MODE.OFF,
  insightListView: basicInsightActions.ACTIVE_VIEWS.LIST
}

export default (state = settingsInitialState, action) => {
  switch (action.type) {
    case settingsMyAccountActions.PUBLISH_COLUMNS:
      return ReduxService.updateObject(state, { columns: action.columns })
    case settingsMyAccountActions.PUBLISH_DISPLAY:
      return ReduxService.updateObject(state, { symbolsDisplay: action.symbolsDisplay, storageGroupsHidden: action.storageGroupsHidden, downloadFormat: action.downloadFormat, dateFormat: action.dateFormat, roundingMode: action.roundingMode, decimalPrecision: action.decimalPrecision })
    case settingsMyAccountActions.SET_SETTINGS: 
      return ReduxService.updateObject(state, action.settings)
    case settingsMyAccountActions.CHANGE_SETTING: {
      if(state[action.name] !== action.value) {
        return ReduxService.updateObject(state, { [action.name]: action.value })
      }
      return state;
    }
    case settingsMyAccountActions.REMOVE_SETTING: {
      if(Object.hasOwn(state, action.name)) {
        const settings = { ...state }
        delete settings[action.name]
        return settings
      }
      return state;
    }
    default:
      return state;
  }
}
